<template>
  <section class="hero is-default is-bold">
    <div class="hero-body">
      <div class="container">
        <div class="columns">
          <div class="column is-one-quarter">
            <b-menu>
              <b-menu-list :label="$t('viewScenario1point5Results.label-1')">
                <b-menu-item
                  @click="activate('scenario-editor')"
                  :active="activeModule === 'scenario-editor'"
                >
                  <template slot="label">
                    <nav class="level">
                      <div class="level-left">
                        <div class="level-item">
                          <b-icon icon="crosshairs"></b-icon>
                          {{ $t('viewScenario1point5Results.label-2') }}
                        </div>
                      </div>
                    </nav>
                  </template>
                </b-menu-item>
              </b-menu-list>
            </b-menu>
          </div>
          <div class="column">
            <scenario-editor
              v-if="activeModule === 'scenario-editor' && loaded"
              :editable="false"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { useScenarioStore } from '@/stores/scenario.js'

export default {
  name: 'Scenario1point5Results',
  components: {
    'scenario-editor': () => import('@/components/scenario/ScenarioEditor.vue')
  },
  data () {
    return {
      loaded: false,
      activeModule: 'scenario-editor'
    }
  },
  setup () {
    const scenarioStore = useScenarioStore()
    return { scenarioStore }
  },
  computed: {
    uuid: function () {
      return this.$route.params.uuid
    },
    scenario: function () {
      return this.scenarioStore.item
    }
  },
  methods: {
    activate: function (module) {
      this.activeModule = module
    }
  },
  mounted () {
    const loadingComponent = this.$buefy.loading.open({
      container: null
    })
    this.scenarioStore
      .setFromUUID(this.uuid)
      .then((data) => {
        this.loaded = true
        loadingComponent.close()
      })
      .catch((erreur) => {
        loadingComponent.close()
      })
  }
}
</script>
